export const oidcSettings = {
    authority: process.env.AUTHORITY,
    clientId: 'ims.omsadmin.h5',
    // clientId:'filmpackage.client.h5',
    redirectUri: process.env.CURRENT_WEB+'/oidc-callback',
    post_logout_redirect_uri:process.env.CURRENT_WEB+'/dashboard',
    responseType: 'id_token token',
    scope: 'openid profile AdminManagerClient_api IMS.OMSAPI',
    // scope: 'openid profile externalinfo FilmPackageAPI',
    silentRedirectUri:process.env.CURRENT_WEB+ '/oidc-silent-renew',
    automaticSilentRenew: true, // If true oidc-client will try to renew your token when it is about to expire
    automaticSilentSignin: true // If true vuex-oidc will try to silently signin unauthenticated users on public routes. Defaults to true
}


// WEBPACK FOOTER //
// ./src/config/oidc.js